import { jsx as _jsx } from "react/jsx-runtime";
export function ArrowUpIcon({ className, size }) {
    return (_jsx("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", height: size + 'px', viewBox: "0 -960 960 960", width: size + 'px', children: _jsx("path", { d: "M446-168v-495.15L216.31-433.46 168-481l311-311 313 313-48.31 47.54L512-663.15V-168h-66Z" }) }));
}
//# sourceMappingURL=ArrowUpIcon.js.map